import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=96f8806c&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"
import style0 from "./Help.vue?vue&type=style&index=0&id=96f8806c&prod&scoped=true&lang=css"
import style1 from "./Help.vue?vue&type=style&index=1&id=96f8806c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f8806c",
  null
  
)

export default component.exports